import React from 'react';
import clsx from 'clsx';
import apiService from '../../services/apiService';


// Card that takes the unused Entities and displays them in a card. It also has a delete button that deletes the entity from the project.
const UnusedDataCard = ({ data, selectedProject, setUnusedEntitiesNames, unusedEntities }) => (
  <div className="blueBorderStyle" style={{ width: '23%', margin: '1%', height: '120px' }}>
    <div
      style={{
        display: 'flex',
        width: '100%',
      }}
      className={clsx('titlePopUp2', 'paddingTitle2')}
    >
      <span>{data}</span>
    </div>
    <div className={clsx('paddingTitle2')} style={{ overflowY: 'auto', height: '82%',  }}>
      <button
        className={clsx('icon-button-style2', 'flexRowDirection', 'redLabel')}
        style={{
          width: '50%',
          height: '50%',
          display: 'flex',
          margin: 'auto',
          justifyContent: 'space-evenly',
          alignItems: 'center',
        }}
        onClick={() => deleteEntity(data, selectedProject, setUnusedEntitiesNames, unusedEntities) }
        // id={`deleteProject${project.name}`}
        aria-hidden="true"
      >
        <div className={clsx('fas', 'fa-trash', 'functionsLogoStyle2')} />
        <div> &nbsp;</div>
        <div>delete</div>
      </button>
    </div>
  </div>
);


const deleteEntity = (name, selectedProject, setUnusedEntitiesNames, unusedEntities) => {

    // Delete the entity from the local storage
    let data = JSON.parse(localStorage.getItem('data'));
    const entities = data[selectedProject].annotations[0].entities.filter(entity => entity !== name);
    const combinations = data[selectedProject].annotations[0].combinations.filter(combination => combination.annotationLink !== name);
    data[selectedProject].annotations[0].combinations = combinations;
    data[selectedProject].annotations[0].entities = entities;
    setUnusedEntitiesNames(unusedEntities.filter(entity => entity !== name));
    localStorage.setItem('data', JSON.stringify(data));

    // Delete the entity from the database
    apiService.updateProject2(data[selectedProject]._id, {annotations: data[selectedProject].annotations}).catch(err => console.log(err));

}

export default UnusedDataCard;
